import { Link } from "react-router-dom";
import { Icon } from "@ugitgud/legos/ui/icon/Icon";
import { SvgLolDiscordIcon } from "@ugitgud/legos/ui/icon/SVG/LolDiscordIcon";
import { SvgBrandsGoogle } from "@ugitgud/legos/ui/icon/SVG/BrandsGoogle";
import { SvgBrandsRiot } from "@ugitgud/legos/ui/icon/SVG/BrandsRiot";
import type { OAuthProvider } from "@ugg/shared/components/auth/LoginFormFooter";

const RIOT_DISCLAIMER =
  "U.GG isn't endorsed by Riot Games and doesn't reflect the views or opinions of Riot Games or anyone officially involved in producing or managing League of Legends.";

type SignupFormFooterProps = {
  logInTo?: string;
  onOAuth?: (provider: OAuthProvider) => void;
  oauthDisabled?: boolean;
  oauthError?: string;
};

export const SignupFormFooter = ({ logInTo, onOAuth, oauthDisabled, oauthError }: SignupFormFooterProps) => (
  <>
    <div className="flex items-center my-[20px]">
      <div className="h-[1px] w-full max-w-[131px] bg-[#5c5c8e]" />
      <span className="mx-2 text-[10px] text-lavender-50">OR</span>
      <div className="h-[1px] w-full max-w-[131px] bg-[#5c5c8e]" />
    </div>
    {oauthError && <p className="mb-[8px] text-[14px] text-accent-red-450 font-[500]">{oauthError}</p>}
    <div className="mb-[20px] flex justify-start">
      <button
        type="button"
        className="bg-[#eb0029] rounded-[4px] h-[36px] w-[92px] cursor-pointer flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed"
        aria-label="Sign up with Riot"
        disabled={oauthDisabled}
        onClick={() => onOAuth?.("custom:riot")}
      >
        <Icon icon={<SvgBrandsRiot />} className="w-[20px] h-[20px]" />
      </button>
      <button
        type="button"
        className="bg-[#f7f7f7] rounded-[4px] ml-[12px] h-[36px] w-[92px] cursor-pointer flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed"
        aria-label="Sign up with Google"
        disabled={oauthDisabled}
        onClick={() => onOAuth?.("google")}
      >
        <Icon icon={<SvgBrandsGoogle />} className="w-[20px] h-[20px]" />
      </button>
      <button
        type="button"
        className="bg-[#5865F2] rounded-[4px] ml-[12px] h-[36px] w-[92px] cursor-pointer flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed"
        aria-label="Sign up with Discord"
        disabled={oauthDisabled}
        onClick={() => onOAuth?.("discord")}
      >
        <Icon icon={<SvgLolDiscordIcon />} className="w-[20px] h-[20px]" />
      </button>
    </div>
    <div className="text-lavender-50 text-[14px] font-inter mb-[24px] xs:mb-[48px]">
      Already have an account?{" "}
      {logInTo ? (
        <Link className="underline text-accent-blue-400 font-bold" to={logInTo}>
          Log In.
        </Link>
      ) : (
        <span className="underline text-accent-blue-400 font-bold">Log In.</span>
      )}
    </div>
    <div className="text-accent-gray-200 text-[14px] font-inter">{RIOT_DISCLAIMER}</div>
  </>
);
